import { faroCoreApiClient } from "@api/faro-core-api-client";
import { useToast } from "@flat-ui";
import { useErrorContext } from "@context-providers/error-boundary/error-handling-context";
import { ProjectMemberEvents, TableType } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { FaroCoreApiUtils } from "@stellar/core-api-client";
/**
 * Hook for resending membership invitations.
 * Handles both project and workspace/group/team invitation resending.
 */
export function useResendInvitation({
  companyId,
  subjectType,
  selectedProject,
  canResendInvitationToCompany
}) {
  const {
    openToast
  } = useToast();
  const {
    handleErrorWithToast
  } = useErrorContext();
  const {
    trackEvent
  } = useTrackEvent();
  const isProjectSubject = subjectType === "project";
  const isWorkspaceOrGroupOrTeamSubject = subjectType === "workspace" || subjectType === "group" || subjectType === "team";
  async function resendInvitation(member) {
    trackEvent({
      name: ProjectMemberEvents.resendInvitation,
      props: {
        dataType: isProjectSubject ? TableType.projectMembers : TableType.companyMembers
      }
    });
    try {
      if (selectedProject?.id && isProjectSubject) {
        await faroCoreApiClient.projects.resendProjectMembershipInvite({
          companyId,
          projectId: selectedProject.id,
          email: member.email
        });
      } else if (isWorkspaceOrGroupOrTeamSubject) {
        await faroCoreApiClient.company.resendCompanyMembershipInvite({
          companyId,
          userIdentity: member.email
        });
      } else {
        // No valid context for resending invitation
        return;
      }
      openToast({
        title: "Invitation sent"
      });
    } catch (error) {
      handleErrorWithToast({
        id: `resendInvite-${Date.now().toString()}`,
        title: "Could not send invitation",
        error
      });
    }
  }
  function shouldShowResendInvitation(member_0) {
    if (FaroCoreApiUtils.Member.isMemberActive(member_0)) {
      return false;
    }
    if (isWorkspaceOrGroupOrTeamSubject && !canResendInvitationToCompany) {
      return false;
    }
    return true;
  }
  return {
    resendInvitation,
    shouldShowResendInvitation
  };
}